<script lang="ts">
  import {
    page_size,
    active_page,
    mobile_size_large,
  } from "$components/episodes/gallery_store";
  import Toggler from "$components/layout/Toggler.svelte";
  export let length: number = 0;

  // sets up a clamp to have nice looking markup, lowest = 1, highest = length
  const clamp = (number: number) => Math.max(1, Math.min(number, length));

  $: number_of_pages = Math.ceil(length / $page_size);

  const effect = () => {
    if ($active_page > number_of_pages) $active_page = 1;
  };
  $: $page_size, effect();

  // this is some stupid stuff to make sure state doesn't get out of sync with the toggler
  let w: number;
  let has_been_greater_than_550 = false;
  $: {
    if (w > 550) has_been_greater_than_550 = true;
  }
  $: {
    if (has_been_greater_than_550 && w < 550) {
      $mobile_size_large = true;
    }
  }
</script>

<svelte:window bind:innerWidth={w} />

<div class="util">
  <div class="viewing">
    {#if length <= clamp($page_size * $active_page)}
      Viewing {length} Contributions
    {:else}
      Viewing Contributions
      {clamp($page_size * ($active_page - 1))} - {clamp(
        $page_size * $active_page,
      )} of {length}
    {/if}
  </div>
  <div class="page_size">
    <select bind:value={$page_size}>
      <option value={10}>10 per page</option>
      <option value={25}>25 per page</option>
      <option value={50}>50 per page</option>
      <option value={75}>75 per page</option>
      <option value={100}>100 per page</option>
    </select>

    {#if w < 550}
      <Toggler on:switch={() => ($mobile_size_large = !$mobile_size_large)}>
        <svelte:fragment slot="true">Large</svelte:fragment>
        <svelte:fragment slot="false">Small</svelte:fragment>
      </Toggler>
    {/if}
  </div>
</div>

<style>
.util {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--offDark);
}
@media (max-width: 550px) {
  .util {
    flex-flow: column;
    gap: 0.5rem;
    position: relative;
    margin: 0;
  }
}
.util .page_size {
  display: inline-flex;
  white-space: nowrap;
  align-items: center;
  gap: 1rem;
}
.util .page_size select {
  min-width: 6rem;
}
</style>
